export function waitForEvent(eventEmitter, eventName) {
    return new Promise(function(resolve) {
        var callback = function() {
            resolve();
            eventEmitter.removeEventListener(eventName, callback);
        };
        eventEmitter.addEventListener(eventName, callback);
    });
}

//# sourceMappingURL=wait-for-event.js.map